// extracted by mini-css-extract-plugin
export default {"Logotype":"index-module--Logotype--E6Nx9"};